export default __webpack_public_path__ + "static/media/group5.108a0612.png";